import { useAuth } from "../lib/AuthContext";
import { UserSwitch, ArrowUUpLeft } from "@phosphor-icons/react";
import api from "../lib/api";

// Renders a persistent yellow banner whenever the current voter session was
// created by an admin via /admin/voters/{id}/impersonate. Provides a one-click
// "Return to admin" that restores the admin's saved token.
export default function ImpersonationBanner() {
    const { user } = useAuth();

    if (!user || user.role !== "voter" || !user.impersonated_by) return null;

    const stop = async () => {
        try {
            await api.post("/auth/stop-impersonation");
            localStorage.removeItem("cc_admin_token");
            // Force a full reload so AuthProvider + ProtectedRoute pick up the new
            // admin cookie cleanly, and ?tab=voters drops us back where we started.
            window.location.assign("/admin?tab=voters");
        } catch (e) {
            try { await api.post("/auth/logout"); } catch {}
            localStorage.removeItem("cc_token");
            localStorage.removeItem("cc_admin_token");
            window.location.assign("/login/admin");
        }
    };

    return (
        <div className="sticky top-0 z-50 bg-amber-400 text-amber-950 border-b-2 border-amber-600 shadow-sm" data-testid="impersonation-banner">
            <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-between gap-3 flex-wrap">
                <div className="flex items-center gap-2 text-sm min-w-0">
                    <UserSwitch size={18} weight="duotone" className="text-amber-800 shrink-0" />
                    <span className="font-semibold uppercase tracking-wider text-[11px] bg-amber-950 text-amber-100 rounded px-1.5 py-0.5">
                        Admin Impersonation
                    </span>
                    <span className="truncate">
                        Signed in as <strong className="font-bold">{user.name} ({user.voter_id})</strong>{" "}
                        via <span className="hash-mono">{user.impersonated_by}</span>
                    </span>
                </div>
                <button
                    type="button"
                    onClick={stop}
                    className="inline-flex items-center gap-1.5 bg-amber-950 hover:bg-black text-amber-50 text-xs font-semibold rounded px-3 py-1.5 transition-colors shrink-0"
                    data-testid="stop-impersonation"
                >
                    <ArrowUUpLeft size={13} weight="bold" /> Return to admin
                </button>
            </div>
        </div>
    );
}
